export const DefaultNewGameConceptId = "new";
export const DefaultNewPitchConceptId = "new";
